module.exports = __webpack_public_path__ + "static/img/2859_phase_function_Paper_Points.955e0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2859_phase_function_Paper_Points.png
// module id = 9dTg
// module chunks = 0